export default function cleanCss(style) {
  if (!style) return;
  let newContent = '';
  if (style) {
    Object.entries(style).forEach(([contentKey, contentValue]) => {
      if (contentKey !== 'video' && contentKey !== 'videoFallback' && contentKey !== 'customClasses' && contentKey !== 'backgroundVideoState' && contentKey !== 'backgroundImageState')  {
        if (typeof contentValue === 'string' && !contentValue) {
        } else {
          newContent = `${newContent + contentKey}: ${contentValue};`;
        }
      }      
      return null;
    });
  }

  return newContent;
}
